<template>
  <div class="solution1">
    <!--1:banner-->
    <div class="block s1_banner">
      <div :class="{content:true}">
        <div class="item1">
          <div class="box">
            <p :class="{title:true,animated:true,fadeInUp:isUp,delay1s:true}">未备案域名阻断系统</p>
            <div :class="{detail:true,animated:true,fadeInUp:isUp,delay2s:true}">
              响应公安部和工信部的要求，通过流量镜像发现对未备案域名的访问请求，进行阻断提醒，要求用户进行公安网和ICP备案。
            </div>
            <a :class="{btn:true,animated:true,fadeInUp:isUp,delay3s:true}" @click="goU('startApply')">联系我们</a>
          </div>
        </div>
      </div>
    </div>
    <!--2:方案说明-->
    <div class="block s1_caseD" id="s_animateBox1">
      <div class="title">方案说明</div>
      <div class="caseBox flex_around">
        <div class="box_case">
          <h3 class="case_title">秒封秒解</h3>
          <p :class="{case_txt:true}">牛盾域名阻断系统是杭州牛盾开发的一款面向公安网和ICP服务商的一款信息安全产品。产品主要功能是对未备案的域名的访问进行阻断。服务商只需要把已备案域名添加到该系统中，就可以实现对已备案域名访问放行，对未备案域名访问阻断。该系统目前已在浙江部分城市投入使用，阻断成功率在 99% 以上。</p>
        </div>
        <div class="icon_case flex_center"><i></i></div>
      </div>
    </div>
    <!--3:特色功能-->
    <div class="block s1_special">
      <div class="title">特色功能</div>
      <div class="content">
        <div class="box">
          <ul class="flex_around">
            <li class="item item1">
              <div class="mask">
                <div class="item_cont">
                  <i class="icon icon1"></i>
                  <p class="title">可视化操作</p>
                  <p class="hoverItem">可视化界面操作，维护管理轻松便捷，轻松定义所需要的功能</p>
                </div>
              </div>
            </li>
            <li class="item item2">
              <div class="mask">
                <div class="item_cont">
                  <i class="icon icon2"></i>
                  <p class="title">域名自动检测</p>
                  <p class="hoverItem">对于已备案的域名自动检测，并自动添加到白名单中，实现访问通行</p>
                </div>
              </div>
            </li>
            <li class="item item3">
              <div class="mask">
                <div class="item_cont">
                  <i class="icon icon3"></i>
                  <p class="title">配置完善</p>
                  <p class="hoverItem">完善的系统配置功能，可对阻断规则、日志记录邮件通知、日报发送等功能进行设置</p>
                </div>
              </div>
            </li>
            <li class="item item4">
              <div class="mask">
                <div class="item_cont">
                  <i class="icon icon4"></i>
                  <p class="title">阻断监控</p>
                  <p class="hoverItem">白名单域名，阻断域名日报邮件通知，系统使用情况一览无余</p>
                </div>
              </div>
            </li>
            <li class="item item5">
              <div class="mask">
                <div class="item_cont">
                  <i class="icon icon5"></i>
                  <p class="title">告警通知</p>
                  <p class="hoverItem">备案查询系统故障通知功能，使故障能够在第一时间得到反馈</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--4:应用场景-->
    <div :class="{block:true, s1_apply:true}" id="s_animateBox2">
      <p :class="{title:true}">应用场景</p>
      <div class="content">
        <ul :class="{ul_box:true, flex_between:true,}">
          <li class="flexCol_aroud">
            <div :class="{icon_wrap:true,}"><i class="icon icon1"></i></div>
            <h4 :class="{mid:true,animated:true,fadeIn:isUp2,displayNone:isDisplay2,}">高危端口关闭</h4>
            <div :class="{detail:true,animated:true,fadeIn:isUp2,displayNone:isDisplay2,delay1s: true}">
              通过阻断的方式对数据中心中开放的高危端口和网络服务进行关闭，防止产生黑客攻击及安全事件。
            </div>
          </li>
          <li class="flexCol_aroud">
            <div :class="{icon_wrap:true,}"><i class="icon icon2"></i></div>
            <h4 :class="{mid:true,animated:true,fadeIn:isUp2,displayNone:isDisplay2,}">非法网站拦截</h4>
            <div :class="{detail:true,animated:true,fadeIn:isUp2,displayNone:isDisplay2,delay1s: true}">
              针对工信部/公安网监的要求，对涉及未备案、非法或者敏感信息的网站进行访问阻断，防止进一步产生社会影响。
            </div>
          </li>
          <li class="flexCol_aroud">
            <div :class="{icon_wrap:true,}"><i class="icon icon3"></i></div>
            <h4 :class="{mid:true,animated:true,fadeIn:isUp2,displayNone:isDisplay2,}">安全事件响应</h4>
            <div :class="{detail:true,animated:true,fadeIn:isUp2,displayNone:isDisplay2,delay1s: true}">
              当举办重大活动时，网络应急办统一进行相关网站的安全管控，必要时通过阻断策略进行上下线管理。
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--5:客户案例-->
    <div class="block s1_clientCase" id="s_animateBox3">
      <p class="title">客户案例</p>
      <div class="caseBox flex_between">
        <span class="icon icon_case1">台州大数据中心</span>
        <p :class="{case_txt:true,animated:true,fadeIn:isUp3,displayNone:isDisplay3,}">
          台州大数据中心通过牛盾的阻断系统，实现了对集群内所有网站的安全管控，做到了秒封秒解，大大提高了大数据中心工作效率和应急能力，获得了一致好评！</p>
      </div>
    </div>
    <!--6:联系我们-->
    <div class="block s1_contactUs">
      <canvas id="canvas2" style="width:100%;height:210px;"></canvas>
      <div class="contact flexCol_aroud">
        <p class="txt">如果您对秒封秒解域名阻断系统感兴趣，或有其他疑问</p>
        <div class="button_contact" @click="goU('startApply')">联系我们</div>
        <!--<p>联系电话：0571-8861-6565</p>-->
      </div>
    </div>
    <!--foot-->
    <div class="foot">
      <footBar></footBar>
    </div>
    <!--返回顶部-->
    <returnTop></returnTop>
  </div>
</template>

<script>
  import footBar from '../../components/footerbar'
  import returnTop from '../../components/returnTop'
  import Case from '../../components/case'
  import {getCanvas} from '../../api/common'

  export default {
    name: "product2",
    data() {
      return {
        swiperOption: {
          autoplay: true,
          speed: 500,
          loop: true,
          type: 'custom',
          navigation: {
            nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
            prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
          },
          pagination: {
            el: '.pag',
            bulletElement: "li",

          }
        },
        isUp: false,
        isUp1: false,
        isUp2: false,
        isUp3: false,
        isDisplay1: true,
        isDisplay2: true,
        isDisplay3: true,
      }
    },
    components: {
      footBar, Case,returnTop
    },
    mounted() {
      getCanvas('canvas2');
      this.isUp = true;
      window.addEventListener('scroll', this.scrollFun);
    },
    methods: {
      scrollFun() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;//窗口滚动条滚动高度
        let animateBox1 = document.getElementById('s_animateBox1');
        let animateBox2 = document.getElementById('s_animateBox2');
        let animateBox3 = document.getElementById('s_animateBox3');
        let scrollDiv1 = animateBox1.offsetTop - scrollTop;
        let scrollDiv2 = animateBox2.offsetTop - scrollTop;
        let scrollDiv3 = animateBox3.offsetTop - scrollTop;
        if (scrollDiv1 <= 700) {
          this.isUp1 = true;
          this.isDisplay1 = false;
        }
        if (scrollDiv2 <= 700) {
          this.isDisplay2 = false;
          this.isUp2 = true;
        }
        if (scrollDiv3 <= 700) {
          this.isDisplay3 = false;
          this.isUp3 = true;
        }
      },
      goU(url) {
        this.$router.push({name: url,params:{product:2,title:'预约演示'}});
      },
    },
    destroyed(){
      window.removeEventListener('scroll',this.scrollFun);
    },
  }
</script>

<style scoped lang="scss">
  .s1_apply{
    .mid{
      font-weight: normal;
      font-family: 'pingfang';
    }
    .detail{
      color:#4A4A4A !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/solution/solution1.vue